const AnalyticsEvents = {
    InvitationRequested: '000_InvitationRequested',
    InvitationNotAvailable: '010_InvitationNotAvailable',
    InvitationAvailable: '020_InvitationAvailable',
    InvitationReady: '030_InvitationReady',
    InvitationShown: '040_InvitationShown',
    InvitationClicked: '050_InvitationClicked',
    ChatRequested: '060_ChatRequested',
    ChatWindowLoaded: '070_ChatWindowLoaded',
    ChatStarted: '080_ChatStarted',
    ChatUIRendered: '090_ChatUIRendered',
    ChatRefreshed: '100_ChatRefreshed',
    ChatGreetingShown: '110_ChatGreetingShown',
    SMSRequested: '120_SMSRequested'
};
export default AnalyticsEvents;
